import { connect } from 'react-redux';

import AuthoriserViewer from '../../../sharedComponents/AuthoriserViewer/AuthoriserViewer';
import { getFPBatchSingleAuthorisersList, getFPBatchMultiAuthorisersList } from '../../../states/batch/selectors';
import { getUserId } from '../../../states/user/selectors';

const mapState = (state) => ({
	singleAuthorisersList: getFPBatchSingleAuthorisersList(state),
	multiAuthorisersList: getFPBatchMultiAuthorisersList(state),
	userId: getUserId(state),
});

export default connect(mapState)(AuthoriserViewer);
